module.exports = __webpack_public_path__ + "static/media/background__platform--3.636ffa14.png";